function modal(parentContainer = document, className = "modal") {

	let teacher = document.getElementById("request-teacher");

	if (typeof(teacher) == 'undefined' || teacher == null) {
		return;
	} else {
		document.getElementById("request-teacher").addEventListener("click", () => {
			document.body.className += ' open-modal';
		});
	}

	document.getElementsByClassName("modal-overlay")[0].addEventListener("click", () => {
		closeModal();
	});
	/*document.getElementsByClassName("close-modal")[0].addEventListener("click", () => {
	 closeModal();
	 });*/
	document.addEventListener('keydown', (e) => {
		const keyName = e.key;
		if (keyName == 'Escape') {
			closeModal();
		}
	});
	function closeModal() {
		document.body.className = document.body.className.replace(/\bopen-modal\b/g, "");
	}
}

module.exports = modal;


// WEBPACK FOOTER //
// ./resources/js/modules/modal.js